<template>
  <div class="legal-page">
    <div class="container">
      <header class="header">
        <router-link to="/" class="back-link">← Back to Home</router-link>
        <h1 class="page-title">Privacy Policy</h1>
        <p class="last-updated">Last updated: {{ lastUpdated }}</p>
      </header>

      <div class="content">
        <section class="section">
          <h2>1. Information We Collect</h2>
          <p>We collect information you provide directly to us, such as when you create an account, join our waitlist, or contact us for support.</p>
          
          <h3>Personal Information</h3>
          <ul>
            <li>Email address</li>
            <li>Name (when provided)</li>
            <li>Communication preferences</li>
          </ul>

          <h3>Usage Information</h3>
          <ul>
            <li>App usage statistics</li>
            <li>Learning progress and performance</li>
            <li>Device information</li>
          </ul>
        </section>

        <section class="section">
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Send you updates about Hrafnabók</li>
            <li>Respond to your comments and questions</li>
            <li>Personalize your learning experience</li>
            <li>Analyze usage patterns to improve our app</li>
          </ul>
        </section>

        <section class="section">
          <h2>3. Information Sharing</h2>
          <p>We do not sell, trade, or otherwise transfer your personal information to third parties except:</p>
          <ul>
            <li>With your explicit consent</li>
            <li>To service providers who help us operate our app</li>
            <li>When required by law</li>
            <li>To protect our rights and safety</li>
          </ul>
        </section>

        <section class="section">
          <h2>4. Data Security</h2>
          <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>
        </section>

        <section class="section">
          <h2>5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Delete your account and personal data</li>
            <li>Opt out of marketing communications</li>
            <li>Data portability</li>
          </ul>
        </section>

        <section class="section">
          <h2>6. Cookies and Tracking</h2>
          <p>We use cookies and similar technologies to enhance your experience, analyze usage, and provide personalized content. You can control cookie settings through your browser.</p>
        </section>

        <section class="section">
          <h2>7. Children's Privacy</h2>
          <p>Our service is not intended for children under 13. We do not knowingly collect personal information from children under 13. If you believe we have collected such information, please contact us immediately.</p>
        </section>

        <section class="section">
          <h2>8. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on this page and updating the "Last updated" date.</p>
        </section>

        <section class="section">
          <h2>9. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p class="contact-info">
            Email: privacy@hrafnabok.com
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyPage',
  data() {
    return {
      lastUpdated: new Date().toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      })
    }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: white;
  padding: 2rem 1rem;
}

.container {
  max-width: 48rem;
  margin: 0 auto;
}

.header {
  margin-bottom: 3rem;
  text-align: center;
}

.back-link {
  display: inline-block;
  margin-bottom: 1rem;
  color: hsl(173, 58%, 39%);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.back-link:hover {
  color: hsl(173, 58%, 35%);
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: black;
  margin-bottom: 0.5rem;
}

.last-updated {
  color: #6b7280;
  font-size: 0.875rem;
}

.content {
  line-height: 1.6;
}

.section {
  margin-bottom: 2rem;
}

.section h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: black;
  margin-bottom: 1rem;
}

.section h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: black;
  margin: 1.5rem 0 0.75rem 0;
}

.section p {
  margin-bottom: 1rem;
  color: #374151;
}

.section ul {
  margin-bottom: 1rem;
  padding-left: 1.5rem;
}

.section li {
  margin-bottom: 0.5rem;
  color: #374151;
}

.contact-info {
  background: #f9fafb;
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
}

@media (min-width: 768px) {
  .legal-page {
    padding: 3rem 2rem;
  }
  
  .page-title {
    font-size: 3rem;
  }
}
</style>